"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Rewards API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionStrategyIdToJSON = exports.ActionStrategyIdFromJSONTyped = exports.ActionStrategyIdFromJSON = exports.ActionStrategyId = void 0;
/**
 * Action strategy id
 * @export
 */
exports.ActionStrategyId = {
    EnterGiveaway: 'ENTER_GIVEAWAY',
    EnterGiveawaySteam: 'ENTER_GIVEAWAY_STEAM',
    EnterGiveawayTwitch: 'ENTER_GIVEAWAY_TWITCH',
    EnterGiveawayYoutube: 'ENTER_GIVEAWAY_YOUTUBE'
};
function ActionStrategyIdFromJSON(json) {
    return ActionStrategyIdFromJSONTyped(json, false);
}
exports.ActionStrategyIdFromJSON = ActionStrategyIdFromJSON;
function ActionStrategyIdFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.ActionStrategyIdFromJSONTyped = ActionStrategyIdFromJSONTyped;
function ActionStrategyIdToJSON(value) {
    return value;
}
exports.ActionStrategyIdToJSON = ActionStrategyIdToJSON;
